const TopSellingProductsData = [
  {
    id: 1,
    title: "ASOS Ridley High Waist",
    date: "07 April 2028",
    price: "79.49",
    quantity: "82",
  },
  {
    id: 2,
    title: "Marco Lightweight Shirt",
    date: "25 March 2018",
    price: "128.50",
    quantity: "37",
  },
  {
    id: 3,
    title: "Half Sleeve Shirt",
    date: "17 March 2018",
    price: "39.99",
    quantity: "62",
  },
  {
    id: 4,
    title: "Lightweight Jacket",
    date: "12 March 2018",
    price: "20.00",
    quantity: "184",
  },
  {
    id: 5,
    title: "ASOS Ridley High Waist",
    date: "07 April 2018",
    price: "79.49",
    quantity: "82",
  },
  {
    id: 6,
    title: "Marco Shoes",
    date: "05 March 2018",
    price: "28.49",
    quantity: "69",
  },
];

module.exports = TopSellingProductsData;
